import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import list from '@/components/list'
import search from '@/components/search'

Vue.use(Router)

export default new Router({
  mode:'history',
  base: '/html/tsg/'||'',
  fullPath:'',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index.html',
      name: 'index',
      component: index
    },
    {
      path:'/list.html',
      name:'list',
      component:list
    },
    {
      path:'/search.html',
      name:'search',
      component:search
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js